import { useRouter } from 'next/router';
import { useProduct } from '../ProductProvider';
import { getProductFaq } from '@/service/ProductCommon/getProductFaq';
import { getProductDownload } from '@/service/ProductCommon/getProductDownload';

const generalMap: Record<string, string> = {
    product_ps_delta_delta_3_u: '1909144180150185985',
    product_ps_delta_delta_3_u_p: '1909142130847510529',
};
export default function getProductSpec(generalKey: string) {
    const { state, dispatch } = useProduct();
    const { productMsg, productSupport } = state;
    const { locale = 'us' } = useRouter();

    const getData = async (generalKey: string) => {
        const product = productMsg && productMsg[generalKey];
        const resFaq = await getProductFaq({ spuId: product?.sourceId || generalMap[generalKey] }, locale);
        const resDownload1 = await getProductDownload({ spuIds: product?.sourceId || generalMap[generalKey] }, locale);
        const resDownload2 = await getProductDownload({ spuIds: product?.sourceId || generalMap[generalKey], classify: 'VIDEO_COURSE' }, locale);
        const resDownload3 = await getProductDownload({ spuIds: product?.sourceId || generalMap[generalKey], classify: 'ONLINE' }, locale);
        if (resFaq?.code === '0' && resDownload1?.code === '0' && resDownload2?.code === '0' && resDownload3?.code === '0') {
            dispatch({
                type: 'changeProductSupport',
                payload: {
                    ...productSupport,
                    [generalKey]: {
                        faqList: resFaq.data?.records || [],
                        downloadList: resDownload1?.data?.content || [],
                        videoList: resDownload2?.data?.content || [],
                        onlineList: resDownload3?.data?.content || [],
                    },
                },
            });
        }
    };
    if (!productSupport || !productSupport[generalKey]) {
        getData(generalKey);
    }
    return null;
}
